import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { AuthUsersEffects } from './+state/auth-user.effects';

@NgModule({
  imports: [CommonModule, EffectsModule.forFeature([AuthUsersEffects])],
})
export class SharedDataAccessAuthUsersModule {}
